import {Component, Output, EventEmitter, Input} from '@angular/core';

import { Rule } from '../services/capd.model';
import { RulesService } from '../services/rules.service';

@Component({
  selector: 'rule-delete',
  templateUrl: './rule-delete.component.html',
  // inputs: [ 'selectedRule' ]
})

export class RuleDeleteComponent {
  @Output() ruleDeleted = new EventEmitter();
  isDisabled = true;
  @Input() selectedRule: Rule;

  constructor(private _service: RulesService) { }

  /**
   * Toggle checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Deletes the rule.
   *
   * @async
   * @func onDelete
   */
  onDelete() {
    this._service.deleteRule(this.selectedRule).then(() => this.ruleDeleted.emit(null));
  }

}
